module.exports = __webpack_public_path__ + "static/media/Juan.76a39f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/testimonials/Juan.png
// module id = 1433
// module chunks = 0